import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image/withIEPolyfill';
import { ArrowRightIcon } from 'brand/Icons';
import { SuccessStoryCardContainer } from './styles';

const SuccessStoryCard = ({ title, description, featureImage, author, width, padding }) => {
  const companyLogo = author?.company?.logo?.fullColor?.image;

  const companyLogoWrapper = () => {
    if (companyLogo) {
      return (
        <div className="success-story-card--company-logo-container">
          <Img className="success-story-card--company-logo-image" fluid={companyLogo?.fluid} />
        </div>
      );
    }

    return null;
  };

  return (
    <SuccessStoryCardContainer width={width} padding={padding}>
      <div className="success-story-card--container">
        {featureImage && (
          <div className="success-story-card--image-container">
            <Img
              className="success-story-card--image"
              fluid={featureImage.fluid}
              objectPosition="100% 50%"
              alt={title}
            />
            {companyLogoWrapper()}
          </div>
        )}
        <div className="success-story-card--body-container">
          <div className="success-story-card--content-container">
            {companyLogoWrapper()}
            <div className="success-story-card--title-wrapper">
              <h2
                className="success-story-card--title"
                dangerouslySetInnerHTML={{ __html: title }}
              ></h2>
            </div>
            {description && (
              <div className="success-story-card--description-wrapper">
                <p className="success-story-card--description">{description}</p>
              </div>
            )}
            {author && (
              <p className="success-story-card--author">
                {(author?.firstName || '') + (author?.lastName ? ` ${author?.lastName}` : '')}
              </p>
            )}
            {author?.company && (
              <p className="success-story-card--company">{author?.company?.name || ``}</p>
            )}
          </div>
          <div className="success-story-card--learn-more-button">
            <p className="success-story-card--learn-more-text">Learn more</p>
            <ArrowRightIcon />
          </div>
        </div>
      </div>
    </SuccessStoryCardContainer>
  );
};

SuccessStoryCard.propTypes = {
  textAlign: PropTypes.string, // 'left', 'center', 'right', 'justify'
  width: PropTypes.string,
  buttonTitle: PropTypes.string,
  linkTo: PropTypes.string,
};

SuccessStoryCard.defaultProps = {
  textAlign: 'left',
  width: '784px',
  padding: '40px 35px 28px 52px',
};

export default SuccessStoryCard;
